import { render, staticRenderFns } from "./TemplateQuestionBank.vue?vue&type=template&id=0a0e8060&"
import script from "./TemplateQuestionBank.vue?vue&type=script&lang=ts&"
export * from "./TemplateQuestionBank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports